<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="chapter-title2"><b>CONTENTS</b></p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc"><a href="#/preface1">Preface to the Second Edition</a></p>
<p class="toc1"><a href="#/chap1">1 Island Tourism</a></p>
<p class="toc1"><span href="#/chap2" title="Link target outside of Sample">2 Work and Encounters in Tourism</span></p>
<p class="toc1"><span href="#/chap3" title="Link target outside of Sample">3 The Airport</span></p>
<p class="toc"><span href="#/chap3#ch3-1" title="Link target outside of Sample">Redcap | <i>Wendy Husbands</i></span></p>
<p class="toc"><span href="#/chap3#ch3-2" title="Link target outside of Sample">Teller and Money Exchanger | <i>Joyann Springer</i></span></p>
<p class="toc1"><span href="#/chap4" title="Link target outside of Sample">4 The Hotel</span></p>
<p class="toc"><span href="#/chap4#ch4-1" title="Link target outside of Sample">Taxi Driver | <i>Trevor Mapp</i></span></p>
<p class="toc"><span href="#/chap4#ch4-2" title="Link target outside of Sample">Bartender | <i>Sylvan Alleyne</i></span></p>
<p class="toc"><span href="#/chap4#ch4-3" title="Link target outside of Sample">Guest Services Director | <i>Marilyn Cooper</i></span></p>
<p class="toc"><span href="#/chap4#ch4-4" title="Link target outside of Sample">Room Attendant (Maid) | <i>Sheralyn O'Neale</i></span></p>
<p class="toc"><span href="#/chap4#ch4-5" title="Link target outside of Sample">Security | <i>Errol Sobers</i></span></p>
<p class="toc"><span href="#/chap4#ch4-6" title="Link target outside of Sample">Chef | <i>Malcolm Bovell</i></span></p>
<p class="toc"><span href="#/chap4#ch4-7" title="Link target outside of Sample">Manager | <i>Martin Barrow</i></span></p>
<p class="toc1"><span href="#/chap5" title="Link target outside of Sample">5 The Beach</span></p>
<p class="toc"><span href="#/chap5#ch5-1" title="Link target outside of Sample">Beach Vendor | <i>Rosco Roach</i></span></p>
<p class="toc"><span href="#/chap5#ch5-2" title="Link target outside of Sample">Hotel Water Sports | <i>Zerphyl Greaves</i></span></p>
<p class="toc"><span href="#/chap5#ch5-3" title="Link target outside of Sample">Jet-Ski Operator | <i>Ricky Hinds</i></span></p>
<p class="toc"><span href="#/chap5#ch5-4" title="Link target outside of Sample">Dive Shop | <i>Brian Rock</i></span></p>
<p class="toc1"><span href="#/chap6" title="Link target outside of Sample">6 The Attractions</span></p>
<p class="toc"><span href="#/chap6#ch6-1" title="Link target outside of Sample">Cruise-Ship Shore Excursions | <i>Rosie Hartmann</i></span></p>
<p class="toc"><span href="#/chap6#ch6-2" title="Link target outside of Sample">Island Bus Tours | <i>Anderson Hughes</i></span></p>
<p class="toc"><span href="#/chap6#ch6-3" title="Link target outside of Sample">Co-Pilot, Atlantis Submarines | <i>Michael Walcott</i></span></p>
<p class="toc"><span href="#/chap6#ch6-4" title="Link target outside of Sample">Tour Guide, Harrison's Cave | <i>Malika Marshall</i></span></p>
<p class="toc"><span href="#/chap6#ch6-5" title="Link target outside of Sample">Captain, Jolly Roger Pirate Cruises | <i>Dwayne Parry</i></span></p>
<p class="toc"><span href="#/chap6#ch6-6" title="Link target outside of Sample">Owner-Operator, Cycling Tours | <i>Robert Quintyne</i></span></p>
<p class="toc1"><span href="#/chap7" title="Link target outside of Sample">7 The Research and Promotion of Tourism</span></p>
<p class="toc"><span href="#/chap7#ch7-1" title="Link target outside of Sample">Barbados Hotel and Tourism Association | <i>Colin Jordan</i></span></p>
<p class="toc"><span href="#/chap7#ch7-2" title="Link target outside of Sample">Chief Research Officer, Ministry of Tourism | <i>Everton Gill</i></span></p>
<p class="toc1"><span href="#/chap8" title="Link target outside of Sample">8 Conclusion</span></p>
<p class="toc"><span href="#/epi" title="Link target outside of Sample">Epilogue: Student Encounters with Tourists and Tourism</span></p>
<p class="indent"> </p>
<p class="toc"><span href="#/acknowledgment" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/acksecondedition" title="Link target outside of Sample">Acknowledgments for the Second Edition</span></p>
<p class="toc"><span href="#/bibilography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5025c986